// extracted by mini-css-extract-plugin
module.exports = {"passwordResetContainer":"PasswordReset_passwordResetContainer__EqgCA","resetButtonSpinner":"PasswordReset_resetButtonSpinner__Nb8i7"};